<template>
  <div>
    <el-dialog
      title="选择培训类型"
      append-to-body
      :visible.sync="visible"
      width="70%"
      append-to-body
      :before-close="cancel">
      <div v-html="trainingCategoryName" style="font-size: 15px; text-align: center; margin-top: 15px; margin-bottom: 20px;">
      </div>
      <el-row>
<!--        <el-col :span="6">-->
<!--          <el-card shadow="never" class="tree-card">-->
<!--            <div slot="header" style="text-align: center">-->
<!--              <span>培训类型</span> <span class="required" v-if="allRequired || trainingTypeRequired">*</span>-->
<!--            </div>-->
<!--            <div class="card-tree">-->
<!--              <tree :data="trainingTypeData" @handleNodeClick="trainingTypeHandleNodeClick"></tree>-->
<!--            </div>-->
<!--          </el-card>-->
<!--        </el-col>-->

<!--        <el-col :span="6">-->
<!--          <el-card shadow="never" class="tree-card">-->
<!--            <div slot="header" style="text-align: center">-->
<!--              <span>岗位类型</span> <span class="required" v-if="allRequired || trainingPostRequired">*</span>-->
<!--            </div>-->
<!--            <div class="card-tree">-->
<!--              <tree :data="trainingPostData" @handleNodeClick="trainingPostHandleNodeClick"></tree>-->
<!--            </div>-->
<!--          </el-card>-->
<!--        </el-col>-->

        <el-col :span="12" v-if="isOperating()">
          <el-card shadow="never" class="tree-card">
            <div slot="header" style="text-align: center">
              <span>行业类型</span> <span class="required" v-if="allRequired || trainingIndustryRequired">*</span>
            </div>
            <div class="card-tree" style="margin-bottom: 20px">
              <tree ref="trainingIndustryTree" :data="trainingIndustryData" @handleNodeClick="trainingIndustryHandleNodeClick" :filter="true"></tree>
            </div>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card shadow="never" class="tree-card">
            <div slot="header" style="text-align: center">
              <span>培训类型</span> <span class="required" v-if="allRequired || trainingLevelRequired">*</span>
            </div>
            <div class="card-tree">
              <tree ref="trainingLevelTree" :data="trainingLevelData" @handleNodeClick="trainingLevelHandleNodeClick"></tree>
            </div>
          </el-card>
        </el-col>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import apiDictionary from '@/api/api_dictionary'
import $const from '@/common/constant'
import DIC_API from "../../api/api_dictionary";
import tree from "@/components/training/tree/tree";

export default {
  components: {tree},
  name: "SelectTrainingCategroy",
  props: {
    // 是否展示弹出
    visible: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    // 培训等级 id
    trainingLevelId: {
      type: String,
      default: () => {
        return ''
      }
    },
    trainingLevelName: {
      type: String,
      default: () => {
        return ''
      }
    },
    //行业类型id
    trainingIndustryId: {
      type: String,
      default: () => {
        return ''
      }
    },
    trainingIndustryName: {
      type: String,
      default: () => {
        return ''
      }
    },

    // 岗位id
    trainingPostId: {
      type: String,
      default: () => {
        return ''
      }
    },
    trainingPostName: {
      type: String,
      default: () => {
        return ''
      }
    },

    // 培训类型 ID
    trainingTypeId: {
      type: String,
      default: () => {
        return ''
      }
    },
    trainingTypeName: {
      type: String,
      default: () => {
        return ''
      }
    },

    // categroy name
    trainingCategoryName: {
      type: String,
      default: () => {
        return ''
      }
    },

    allRequired: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    trainingLevelRequired: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    trainingIndustryRequired: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    trainingPostRequired: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    trainingTypeRequired: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  data() {
    return {
      // training level  tree data
      trainingLevelData: [],
      // training industr tree data
      trainingIndustryData: [],
      // training post tree data
      trainingPostData: [],
      // training type tree data
      trainingTypeData: []
    }
  },
  methods: {
    showDialog() {
      this.visible = true;
      //取消选中
      if (this.isOperating()){
        this.$refs.trainingIndustryTree.clearHandle();
      }
      this.$refs.trainingLevelTree.clearHandle();
    },
    /**
     *cancel
     */
    cancel() {
      this.$emit('cancel', {});
      this.visible = false;
    },
    verify(){
      // if ((this.allRequired ||  this.trainingTypeRequired) &&!this.trainingTypeId){
      //   this.$message.error('请选择培训类型');
      //   return false;
      // }
      // if ((this.allRequired ||  this.trainingPostRequired) &&  !this.trainingPostId){
      //   this.$message.error('请选择岗位');
      //   return false;
      // }
      if (this.isOperating()){
        if ((this.allRequired ||  this.trainingIndustryRequired) && !this.trainingIndustryId){
          this.$message.error('请选择行业');
          return false;
        }
      }
      if ((this.allRequired ||  this.trainingLevelRequired) && !this.trainingLevelId){
        this.$message.error('请选择培训类型');
        return false;
      }
      return true;
    },
    /**
     * submit
     */
    submit() {
      if (!this.verify()) {
        return;
      }

      this.$emit('submit', {
        // 培训等级 id
        trainingLevelId: this.trainingLevelId,
        trainingLevelName: this.trainingLevelName,
        //行业类型id
        trainingIndustryId: this.trainingIndustryId,
        trainingIndustryName: this.trainingIndustryName,
        // 岗位id
        trainingPostId: this.trainingPostId,
        trainingPostName: this.trainingPostName,
        // 培训类型 ID
        trainingTypeId: this.trainingTypeId,
        trainingTypeName: this.trainingTypeName,
        // categroy name
        trainingCategoryName: this.trainingCategoryName,
      });
      this.visible = false;
    },
    nodeText(node) {
      if (node.parent && node.parent.level >= 1) {
        return this.nodeText(node.parent) + "-" + node.data.text;
      } else {
        return node.data.text;
      }
    },
    // handleNodeClick functions
    allHandleNodeClick(node, componentInit) {
      this.trainingCategoryName = "";
      if (this.trainingTypeName) {
        this.trainingCategoryName += "/" + this.trainingTypeName;
      }
      if (this.trainingPostName) {
        this.trainingCategoryName += "/" + this.trainingPostName;
      }
      if (this.trainingIndustryName) {
        this.trainingCategoryName += "/" + this.trainingIndustryName;
      }
      if (this.trainingLevelName) {
        this.trainingCategoryName += "/" + this.trainingLevelName;
      }

      this.trainingCategoryName = this.trainingCategoryName.substring(1);
    },
    trainingTypeHandleNodeClick(node, componentInit) {
      console.log(node);
      if (node){
        this.trainingTypeId = node.object.code;
        this.trainingTypeName = this.nodeText(componentInit);
      }
      this.allHandleNodeClick(node, componentInit);
    },
    trainingLevelHandleNodeClick(node, componentInit) {
      console.log(node);
      if (node){
        this.trainingLevelId = node.object.code;
        this.trainingLevelName = this.nodeText(componentInit);
      } else {
        this.trainingLevelId = undefined;
        this.trainingLevelName = undefined;
      }
      this.allHandleNodeClick(node, componentInit);
    },
    trainingIndustryHandleNodeClick(node, componentInit) {
      console.log(node);
      if (node){
        this.trainingIndustryId = node.object.code;
        this.trainingIndustryName = this.nodeText(componentInit);
      } else {
        this.trainingIndustryId = undefined;
        this.trainingIndustryName = undefined;
      }
      this.allHandleNodeClick(node, componentInit);
    },
    trainingPostHandleNodeClick(node, componentInit) {
      console.log(node);
      if (node){
        this.trainingPostId = node.object.code;
        this.trainingPostName = this.nodeText(componentInit);
      }
      this.allHandleNodeClick(node, componentInit);
    },
    // load data s
    loadTrainingLevelData() {
      //获取培训类型
      DIC_API.getDictionaryResolveToTree({
        code: $const.dictionary.TRAINING_LEVEL
      }).then((res) => {
        if (res && res.data) {
          this.trainingLevelData = res.data.children;
        }
      });
    },
    loadTrainingIndustryData() {
      //获取培训类型
      DIC_API.getDictionaryResolveToTree({
        code: $const.dictionary.TRAINING_INDUSTRY
      }).then((res) => {
        if (res && res.data) {
          this.trainingIndustryData = res.data.children;
        }
      });
    },
    loadTrainingPostData() {
      //获取培训类型
      DIC_API.getDictionaryResolveToTree({
        code: $const.dictionary.TRAINING_POST
      }).then((res) => {
        if (res && res.data) {
          this.trainingPostData = res.data.children;
        }
      });
    },
    loadTrainingTypeData() {
      //获取培训类型
      DIC_API.getDictionaryResolveToTree({
        code: $const.dictionary.TRAINING_TYPE
      }).then((res) => {
        if (res && res.data) {
          this.trainingTypeData = res.data.children;
        }
      });
    },
    /**
     * 判断是否是运营人员
     */
    isOperating(){
      let userInfo = JSON.parse(localStorage.getItem('userinfo'));
      return 'admin' == userInfo.name;
    }
  },
  mounted() {
    // load data
    this.loadTrainingTypeData();
    this.loadTrainingPostData();
    this.loadTrainingIndustryData();
    this.loadTrainingLevelData();
  }
}
</script>

<style scoped>
.tree-card {
  height: 460px;
}

.card-tree {
  height: 350px;
}

.el-scrollbar__wrap {
  overflow-x: hidden;

}
.required {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/training/selectTrainingCategory.vue